import { PROVIDERS } from './constants';

const { HANDIN } = PROVIDERS;

const filterAssignment = (assignment) => ({ objectId, externalId }) => {
  if (assignment.provider === HANDIN) {
    return externalId !== assignment.externalId;
  }
  return objectId !== assignment.objectId;
};

export default filterAssignment;
